import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './directive';
import org from '@/components/organization/';
import rdiff from 'recursive-diff';
import { saveFullAttendanceBonus, fullAttendanceBonusList } from '@/api/payroll/management';
import { mapState } from 'vuex';
export default {
  components: {
    org: org
  },
  props: {
    currentData: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: _objectSpread({}, mapState({
    // 货币
    currency: function currency(state) {
      return state.user.company_info.currency;
    }
  })),
  data: function data() {
    return {
      orgIndex: 0,
      cAttendanceData: {},
      // 当前选中项
      attendanceData: {
        name: 'payroll_management_21',
        is_setting: false,
        status: '0',
        conditions: [],
        pfa_list: [{
          my_is_tax: false,
          my_is_ss: false,
          is_ss: '0',
          // 是否社保 0 关闭 1开启
          is_tax: '0',
          // 是否算税 0 关闭 1开启
          provide_condition: [],
          // 生效规则
          provide_way: '0',
          // 0固定额度，1递增额度
          provide_way_0: '',
          // 固定额度的值
          provide_way_1: {
            1: '',
            2: ''
          },
          // 递增额度的值
          staff_info_ids: [],
          // 用户id
          department_id: [],
          // 部门id
          department_list: [],
          staff_list: []
        }]
      },
      status: false
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    window.removeEventListener('popstate', window.pushStateFun, false);
    if (this.status) next();else {
      var diff = rdiff.getDiff(this.attendanceData.pfa_list, this.cAttendanceData.pfa_list);
      if (!diff.length) next();else {
        this.$confirm(this.$t('payroll_management_28'), this.$t('payroll_management_27'), {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        }).then(function () {
          next();
        }).catch(function () {});
      }
    }
  },
  mounted: function mounted() {
    this.handleEdit();
    this.preventBack();
  },
  methods: {
    preventBack: function preventBack() {
      var this_ = this;
      window.pushStateFun = function () {
        var diff = rdiff.getDiff(this_.attendanceData.pfa_list, this_.cAttendanceData.pfa_list);
        if (!diff.length) this_.handlerBack();else {
          this_.$confirm(this_.$t('payroll_management_28'), this_.$t('payroll_management_27'), {
            confirmButtonText: this_.$t('submit_btn'),
            cancelButtonText: this_.$t('cancel_btn'),
            type: 'warning'
          }).then(function () {
            this_.status = true;
            this_.handlerBack();
          }).catch(function () {
            var state = {
              title: null,
              url: document.UTL // 要禁掉的页面
            };
            /*
                三个参数：
                state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
                title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
                url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
              */
            window.history.pushState(state, null, document.UTL); // 要禁掉的页面
          });
        }
      };

      var state = {
        title: null,
        url: document.UTL // 要禁掉的页面
      };

      window.history.pushState(state, null, document.UTL); // 要禁掉的页面
      window.addEventListener('popstate', window.pushStateFun, false);
    },
    handlerBack: function handlerBack() {
      // 返回列表页
      this.$router.push({
        path: '/payroll/items'
      });
    },
    handleEdit: function handleEdit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data, pfaStatus;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fullAttendanceBonusList();
            case 2:
              res = _context.sent;
              if (res.code === 1 && res.data) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              data = res.data;
              pfaStatus = data.pfa_list && data.pfa_list.length;
              _this.attendanceData.conditions = data.conditions;
              _this.attendanceData.pfa_list = pfaStatus ? data.pfa_list : _this.attendanceData.pfa_list;
              _this.attendanceData.pfa_list.forEach(function (item) {
                item.provide_way_1 = item.provide_way_1 ? item.provide_way_1 : {
                  1: '',
                  2: ''
                };
                _this.$set(item, 'orgVisible', false); // 选择人员弹窗
                _this.$set(item, 'my_is_tax', item.is_tax === '1'); // 计算税
                _this.$set(item, 'my_is_ss', item.is_ss === '1'); // 社保
                _this.$set(item, 'department_list', item.department_id); // 选择人员需向弹窗传的参数
                _this.$set(item, 'staff_list', item.staff_info_ids); // 选择人员需向弹窗传的参数
                // 千分位
                item.provide_way_0 = Number(item.provide_way_0).toLocaleString();
                // 发放条件为逐月递增 provide_way_1的值是否为空
                if (item.provide_way === '1') {
                  Object.keys(item.provide_way_1).forEach(function (key) {
                    // 千分位
                    var e = item.provide_way_1[key];
                    item.provide_way_1[key] = Number(e).toLocaleString();
                  });
                }
                item.department_id = [];
                item.staff_info_ids = [];
                item.provide_condition = item.provide_condition ? item.provide_condition : [];
                // 后端给的数据是数组+对象，在department_id字段中只用保留id
                if (item.department_list.length) {
                  item.department_list.forEach(function (department) {
                    department.department_id = department.id;
                    department.department_name = department.name;
                    item.department_id.push(department.id);
                  });
                }
                // 后端给的数据是数组+对象，在staff_info_ids字段中只用保留id
                var staffs = [];
                if (Array.isArray(item.staff_list)) {
                  item.staff_list.forEach(function (staff) {
                    item.staff_info_ids.push(staff.id);
                    staffs.push({
                      staff_id: staff.staff_id || staff.id,
                      staff_name: staff.staff_name || staff.name,
                      staff_name_en: staff.staff_name_en,
                      staff_name_secondary: staff.staff_name_secondary,
                      staff_name_th: staff.staff_name_th || staff.name,
                      avatar_url: staff.avatar_url || '',
                      id: staff.id
                    });
                  });
                }
                item.staff_list = staffs;
              });
              _this.cAttendanceData = JSON.parse(JSON.stringify(_this.attendanceData));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 删除
    handleDel: function handleDel(index) {
      var _this2 = this;
      this.$confirm(this.$t('payroll_management_50'), '', {
        confirmButtonText: this.$t('submit_btn'),
        cancelButtonText: this.$t('cancel_btn'),
        type: 'warning'
      }).then(function () {
        _this2.attendanceData.pfa_list.splice(index, 1);
      }).catch(function () {});
    },
    handleAdd: function handleAdd() {
      this.attendanceData.pfa_list.push({
        my_is_ss: false,
        my_is_tax: false,
        is_ss: '0',
        // 是否社保 0 关闭 1开启
        is_tax: '0',
        // 是否算税 0 关闭 1开启
        provide_condition: [],
        // 生效规则
        orgVisible: false,
        // 是否展示选择人员弹窗
        provide_way: '0',
        // 0固定额度，1递增额度
        provide_way_0: '',
        // 固定额度的值
        provide_way_1: {
          1: '',
          2: ''
        },
        // 递增额度的值
        staff_info_ids: [],
        // 用户id
        department_id: [],
        // 部门id
        staff_list: [],
        department_list: []
      });
    },
    handlerDelete: function handlerDelete(value, key) {
      this.$delete(value.provide_way_1, key);
    },
    // 逐月递增添加数据
    handlerEdit: function handlerEdit(value) {
      var keys = Object.keys(value.provide_way_1);
      if (keys.length < 12) {
        this.$set(value.provide_way_1, keys.length + 1, '');
      }
    },
    // 打开选择人员弹窗
    openOrg: function openOrg(pfa, index) {
      this.orgIndex = index;
      pfa.orgVisible = true;
    },
    // 选择成员
    handleSelectDepart: function handleSelectDepart(params) {
      var _this3 = this;
      var pfa_list = this.attendanceData.pfa_list;
      var item = pfa_list[this.orgIndex];
      item.department_list = params.dept_list;
      item.staff_list = params.staff_list;
      item.department_id = this.formateList(params.dept_list, 'department_id');
      item.staff_info_ids = this.formateList(params.staff_list, 'staff_id');
      // 其他计算规则中如果有选择相同的部门和人，需删除
      pfa_list.forEach(function (pfa, pfaIndex) {
        pfa.staff_list.forEach(function (staff, staffIndex) {
          if (pfaIndex !== _this3.orgIndex) {
            if (params.staffIds.includes(staff.staff_id)) {
              pfa.staff_list.splice(staffIndex, 1);
              pfa.staff_info_ids.splice(staffIndex, 1);
            }
          }
        });
        pfa.department_list.forEach(function (dep, depIndex) {
          if (pfaIndex !== _this3.orgIndex) {
            if (params.depIds.includes(dep.department_id)) {
              pfa.department_list.splice(depIndex, 1);
              pfa.department_id.splice(depIndex, 1);
            }
          }
        });
      });
    },
    // 数据格式化
    formateList: function formateList(obj, key) {
      return obj.map(function (item) {
        return item[key];
      });
    },
    handleForm: function handleForm() {
      // 判断所有payee - info必填项是否为空
      var validBase = [];
      var payeeInfo = this.$refs['payee-info'];
      payeeInfo.forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                item.validate(function (valid) {
                  validBase.push(valid);
                });
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      return validBase;
    },
    onConfirm: function onConfirm() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var validBase, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              validBase = _this4.handleForm();
              if (!validBase.includes(false)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              // 必填项不为空执行下面代码
              _this4.attendanceData.pfa_list.forEach(function (item) {
                item.is_ss = item.my_is_ss ? '1' : '0';
                item.is_tax = item.my_is_tax ? '1' : '0';
                if (item.provide_condition.length <= 0) delete item.provide_condition;
                if (item.provide_way === '0') {
                  item.provide_way_1 = {};
                  if (isNaN(item.provide_way_0)) item.provide_way_0 = item.provide_way_0.split(',').join('');
                } else {
                  item.provide_way_0 = '';
                  var keys = Object.keys(item.provide_way_1);
                  keys.forEach(function (key) {
                    var i = item.provide_way_1[key];
                    if (isNaN(i)) item.provide_way_1[key] = i.split(',').join('');
                  });
                }
              });
              // 调用保存接口
              _context3.next = 6;
              return saveFullAttendanceBonus({
                pfa_list: _this4.attendanceData.pfa_list
              });
            case 6:
              res = _context3.sent;
              if (res.code === 1) {
                _this4.status = true;
                _this4.$router.push({
                  path: '/payroll/items'
                });
                _this4.$message({
                  message: res.message,
                  type: 'success'
                });
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};